import type { ProductsData } from '@/app/api/search/products/createProductsData.ts';
import type { DealCard } from './buildDealCards/dealCardTypes';
import type { Localization } from '../common/Localization';

export const hasAirportsOrStations = (productsData: ProductsData): boolean =>
  Array.isArray(productsData?.transport?.airports) && productsData.transport.airports.length > 0;

export const hasAirportsAndStations = (productsData: ProductsData): boolean => {
  const airports = productsData?.transport?.airports;
  if (!Array.isArray(airports) || airports.length === 0) return false;

  return airports.some((airport) => 'isStation' in airport && airport.isStation === true);
};

export const hasStationsOnly = (productsData: ProductsData): boolean => {
  const airports = productsData?.transport?.airports;
  if (!Array.isArray(airports) || airports.length === 0) return false;

  return airports.every((airport) => 'isStation' in airport && airport.isStation === true);
};

export const hasAirportsOnly = (productsData: ProductsData): boolean => {
  const airports = productsData?.transport?.airports;
  if (!Array.isArray(airports) || airports.length === 0) return false;

  return airports.every((airport) => 'isStation' in airport && airport.isStation === false);
};

export const hasPackageSavingsEnabled = (dealCard: DealCard, localization: Localization): boolean =>
  dealCard?.product?.rate?.packageDiscount?.enabled && localization?.configValuesApp?.packageSavingsEnabled;
